import React from "react";
import PackageDetails from "./PackageDetails";

export default function Index() {
  const MemoizedPackageDetails = React.memo(PackageDetails);
  return <MemoizedPackageDetails />;
}
